// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1hpih","item":"PaymentsMobile_item__2hNrc","label":"PaymentsMobile_label__2eHG3","amount":"PaymentsMobile_amount__3OoCC"};